import { useState } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../../lib/db.ts';
import { resetThisDevice } from '../../services/device.ts';
import { Alert, Button, FullScreenMessage } from '../../ui/index.tsx';

/** El dueño deshabilitó este dispositivo desde otro. */
export function DeviceRevokedScreen() {
  const pending = useLiveQuery(() => db.outbox.where('status').equals('pending').count(), [], 0);
  const [confirming, setConfirming] = useState(false);

  return (
    <FullScreenMessage title="Este dispositivo fue deshabilitado">
      <p>El dueño del negocio le quitó el acceso a este dispositivo. Para volver a usarlo, tiene que habilitarlo de nuevo.</p>
      {pending > 0 && (
        <Alert tone="warning">
          Quedan {pending} cambios sin enviar al servidor. Si borrás los datos, esos cambios se pierden.
        </Alert>
      )}
      {confirming ? (
        <div className="flex justify-center gap-2">
          <Button variant="secondary" onClick={() => setConfirming(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={() => void resetThisDevice()}>
            Sí, borrar datos
          </Button>
        </div>
      ) : (
        <Button variant="secondary" onClick={() => setConfirming(true)}>
          Borrar datos de este dispositivo
        </Button>
      )}
    </FullScreenMessage>
  );
}
